
import React, { useEffect, useState } from 'react'
import { Row, Table, Button, Col, Form, Modal, Input, message, Tag, Select } from 'antd'
import { SaveOutlined } from '@ant-design/icons'
import { findAttributeItemOrValues, deleteAttribute, getAttributeById } from '@services/attributeService'
import AttributeEdit from '../../../containers/attributeEdit'
import AttributeValueEdit from '../../../containers/attributeEdit/AttributeValueEdit'
import './index.scss'
import { showError } from '@utils/alert'
import moment from 'moment'

const { confirm } = Modal
const PAGE_SIZE = 10

const AttrTypeIndex = ['属性值', '属性项']

function AttributeItemList() {
  const [form] = Form.useForm()
  const [tableLoading, setTableLoading] = useState(false)
  const [dialogVisible, setDialogVisible] = useState(false)
  const [valueDialogVisible, setValueDialogVisible] = useState(false)
  const [current, setCurrent] = useState(1)
  const [selectedItemId, setSelectedItemId] = useState(null)
  const [editValue, setEditValue] = useState<any>(null)
  const [list, setList] = useState<any[]>([])
  const [total, setTotal]: [any, any] = useState()

  function onEdit(r: any) {
    setSelectedItemId(r.id)
    if (r.type === 1) {
      if (dialogVisible) return
      setDialogVisible(true)
    } else {
      if (valueDialogVisible) return
      setEditValue(r)
      setValueDialogVisible(true)
    }
  }

  function onNewItem() {
    setSelectedItemId(null)
    if (dialogVisible) return
    setDialogVisible(true)
  }

  function onDelete(record) {
    const { id } = record
    confirm({
      title: '删除',
      content: `确认删除属性: ${id} 吗？`,
      okText: '确认',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
          const hide = message.loading('删除中...')
          deleteAttribute(id)
            .then(res => {
              hide()
              message.success(`删除属性项:${id} 成功`)
              handleSearch()
            })
            .catch(e => {
              hide()
              console.error(e)
              showError(e)
            })
      },
      onCancel() {
        
      },
    })
  }

  const columns = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      width: 120,
    }, {
      title: 'Parent',
      dataIndex: 'parent_id',
      key: 'parent_id',
      width: 100,
    }, {
      title: 'Name',
      dataIndex: 'value',
      key: 'value',
      width: 120,
    }, {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      width: 100,
      render: (type) => AttrTypeIndex?.[+type] || ''
    }, {
      title: 'Alias',
      dataIndex: 'alias',
      key: 'alias',
      width: 100,
      render: (alias) => {
        return Array.isArray(alias) ? alias.map(a => <Tag key={a}>{a}</Tag>) : null
      }
    }, {
      title: 'Created At',
      dataIndex: 'created_at',
      width: 150,
      render: (record) => {
        return moment(record).format('YYYY-MM-DD HH:mm')
      }
    }, {
      title: 'Modified At',
      dataIndex: 'last_modified_at',
      width: 150,
      render: (record) => {
        return moment(record).format('YYYY-MM-DD HH:mm')
      }
    }, {
      title: 'Status',
      dataIndex: 'valid',
      width: 80,
      render: (valid) => {
        return valid ? '启用' : '禁用'
      }
    }, {
      title: 'Search Filter',
      dataIndex: 'enabled_search_filter',
      width: 120,
      render: (filter, record) => {
        return !!filter ? '启用' : '禁用'
      }
    }, {
      title: 'Actions',
      key: 'action',
      width: '250px',
      render: (record) => (
        <Row>
          <Col span={8}>
            <Button type="primary" onClick={() => onEdit(record)}>编辑</Button>
          </Col>
          <Col span={8}>
            <Button danger onClick={() => onDelete(record)}>删除</Button>
          </Col>
        </Row>
      )
    }
  ]

  function handleSearch() {
    setCurrent(1)
    searchAttributeList(current)
  }

  function searchAttributeList(current: number) {
    form.validateFields().then((values) => {
        setTableLoading(true)
        const from = (current - 1) * PAGE_SIZE
        const getList = values.method === 'name'
          ? findAttributeItemOrValues(from, from + PAGE_SIZE, values.name, values.type)
          : getAttributeById(values.id)
        getList.then(res => {
            if (res.data) {
              if (res.data?.items?.length) {
                setList(res.data.items)
                setTotal(res.data.total)
              } else if (res.data.id) {
                setList([res.data])
                setTotal(1)
              } else {
                setList([])
                setTotal(0)
              } 
            }
            setTableLoading(false)
          })
          .catch(e => {
            showError(e)
            setTableLoading(false)
            console.error(e)
          })
    })
  }

  function handleCurrentPageChange(current) {
    setCurrent(current)
    searchAttributeList(current)
  }

  useEffect(() => {
    handleSearch()
  }, [])

  return (
    <div className="p-attributes">
      <Form layout="inline" name="attribute-items" form={form}>
        <Form.Item label="Type" name="type" initialValue={1} style={{ marginRight: '15px' }}>
          <Select style={{ width: 120 }}>
            <Select.Option value={0}>属性值</Select.Option>
            <Select.Option value={1}>属性项</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item name="method" initialValue={'name'} style={{ marginRight: '15px' }}>
          <Select style={{ width: 120 }}>
            <Select.Option value="name">Name</Select.Option>
            <Select.Option value="id">Id</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item shouldUpdate={(prevValues, curValues) => prevValues.method !== curValues.method}>
            {() => {
              switch (form.getFieldValue('method')) {
                case 'id':
                  return (
                    <Form.Item
                      name="id"
                      rules={[
                        {
                          required: true,
                          message: 'Please input the id',
                        },
                      ]}
                    >
                      <Input allowClear placeholder="匹配属性值/属性项 id"></Input>
                    </Form.Item>
                  )
                case 'name':
                default:
                  return (
                    <Form.Item name="name">
                      <Input allowClear placeholder="模糊匹配关键词"></Input>
                    </Form.Item>
                  )
              }
            }}
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={handleSearch}>
            查询
          </Button>
        </Form.Item>
        <Form.Item>
          <Button icon={<SaveOutlined />} onClick={onNewItem}>
            新建
          </Button>
        </Form.Item>
      </Form>
      <Table
        style={{ backgroundColor: '#ffffff' }}
        tableLayout="fixed"
        columns={columns}
        dataSource={list}
        loading={tableLoading}
        rowKey={(record: any) => record.id}
        pagination={{
          current: current,
          pageSize: PAGE_SIZE,
          total: total,
          showQuickJumper: true,
          onChange: handleCurrentPageChange,
          style: {
            paddingRight: '20px'
          }
        }}
      />
      <AttributeEdit
        id={selectedItemId}
        visible={dialogVisible}
        onCancel={() => {
          setSelectedItemId(null)
          setDialogVisible(false)
          handleSearch()
        }}
      />
      <AttributeValueEdit
        visible={valueDialogVisible}
        id={selectedItemId}
        value={editValue}
        onCancel={() => {
          setEditValue(null)
          setValueDialogVisible(false)
        }} 
      />
    </div>
  )
}

export default AttributeItemList
